import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  style: {"white-space":"pre-wrap","margin-top":"12px"}
}

import { onMounted, ref } from "vue";
import App from "./app/App.vue";
import AppStart from "./app/AppStart.vue";
import AppError from "./app/AppError.vue";

import { useAccountStore } from "@/stores/accountStore";
import apiAuth from "@/shared/services/apiAuth";

import Keycloak, { type KeycloakConfig } from "keycloak-js";

type BootstrapState = "loading" | "error" | "ready";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBootstrap',
  setup(__props) {

const state = ref<BootstrapState>("loading");
const errorMessage = ref<string>("");

onMounted(async () => {
  try {
    const resp = await apiAuth.init();

    if (!resp.successful) {
      state.value = "error";
      errorMessage.value = String(resp.message ?? "Unbekannter Fehler bei apiAuth.init()");
      return;
    }

    const accountStore = useAccountStore();
    accountStore.setInstallation(resp);

    const keycloakConfig = resp.keycloak;

    if (keycloakConfig.active && resp.shopId !== "eVB_Aktivierung") {
      const initOptions: KeycloakConfig = {
        url: keycloakConfig.keycloakUrl || "",
        realm: keycloakConfig.realm || "",
        clientId: keycloakConfig.clientId || "",
      };

      const keycloak = new Keycloak(initOptions);
      apiAuth.setKeycloak(keycloak);

      const auth = await keycloak.init({
        onLoad: "check-sso",
        silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
        checkLoginIframe: false,
      });

      accountStore.authenticated = keycloak.authenticated === true;

      if (auth) {
        await apiAuth.authenticatePrivate();
      }
    }

    state.value = "ready";
  } catch (e) {
    console.error(e);
    state.value = "error";
    errorMessage.value = e instanceof Error ? e.message : String(e);
  }
});

return (_ctx: any,_cache: any) => {
  return (state.value === 'loading')
    ? (_openBlock(), _createBlock(AppStart, { key: 0 }))
    : (state.value === 'error')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(AppError),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("pre", _hoisted_2, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(App, { key: 2 }))
}
}

})